export default __webpack_public_path__ + "static/img3-83533060138f48b938dc389c3d5dc438.png";